import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';

const AtmEcom = ({setSelectedField}) => {
 
  const [checkboxStates, setCheckboxStates] = useState({
      unauthorized: false,
      paidByOther: false,
      unsuccessful: false,
      differentAmount: false,
      duplicate: false,
      other: false,
    });
    const [agreementChecked, setAgreementChecked] = useState(false);
    const [showAgreementError, setShowAgreementError] = useState(false);
  
    useEffect(() => {
      const forms = document.querySelectorAll(".needs-validation");
  
      Array.from(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            // Check if at least one checkbox is checked
            const anyChecked = Object.values(checkboxStates).some(
              (value) => value === true
            );
  
            if (!anyChecked) {
              setShowError(true);
            } else {
              setShowError(false);
            }
  
            // Check if agreement checkbox is checked
            if (!agreementChecked) {
              setShowAgreementError(true);
            } else {
              setShowAgreementError(false);
            }
  
            if (!anyChecked || !agreementChecked || !form.checkValidity()) {
              form.classList.add("was-validated");
              return;
            }
  
            form.classList.add("was-validated");
  
            // Add your form submission logic here
            console.log("Form is valid, submitting...");
          },
          false
        );
      });
    }, [checkboxStates, agreementChecked]);
  
    const [specificMessage, setSpecificMessage] = useState(false);
    const [message, setMessage] = useState();
  
    const [showError, setShowError] = useState(false);
  
    // Function to handle checkbox changes
    const handleCheckboxChange = (checkboxName) => {
      const newStates = {
        ...checkboxStates,
        [checkboxName]: !checkboxStates[checkboxName],
      };
      setCheckboxStates(newStates);
  
      // Check if at least one checkbox is checked
      const anyChecked = Object.values(newStates).some((value) => value === true);
      setShowError(!anyChecked);
    };
  return (
    <div>
      <Row className="mb-2">
        <Col sm={12} lg={6}>
          <label htmlFor="disputeType" className="form-label text-black">
            Dispute Type*
          </label>
          <select
            className="form-select mb-3"
            id="disputeType"
            aria-label="Default select example"
            required
            defaultValue=""
            onChange={(e) => setSelectedField(e.target.value)}
          >
          
            <option value="Atm">ATM/POS/Ecommerce</option>
            <option value="MobileBanking">Mobile Banking/QR</option>
            <option value="iTouch">iTouch</option>
          </select>
          <div className="invalid-feedback">
            You must select a dispute type before submitting.
          </div>
        </Col>
        <Col sm={12} lg={6}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Card Number*
            </label>
            <input
              type="number"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter account holder's name.
            </div>
          </div>
        </Col>
      </Row>
       <Row className="mb-4">
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Card Type
            </label>
            <select
            className="form-select mb-3"
            id="cardType"
            aria-label="Default select example"
            required
            defaultValue=""
          >
            <option value="" disabled hidden>
              Select card type
            </option>
            <option value="International Visa Debit Card">International Visa Debit Card</option>
            <option value="International Visa Credit Card">International Visa Credit Card</option>
            <option value="Domestic Visa Debit Card">Domestic Visa Debit Card</option>
          </select>
          <div className="invalid-feedback">
            You must select a dispute type before submitting.
          </div>
          </div>
        </Col>
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Account Holder's Name*
            </label>
            <input
              type="text"
              className="form-control"
              id="placeholderInput"
              placeholder="Select date"
              required
              defaultValue=""
              onFocus={(e) => (e.target.type = "date")} // show date picker on focus
              onBlur={(e) => {
                // revert to text if empty
                if (!e.target.value) {
                  e.target.type = "text";
                }
              }}
            />

            <div className="invalid-feedback">
              You must enter transaction date.
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col >
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Trace Number*
            </label>
            <input
              type="number"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div>
              <p className='fs-6 text-black'>(To be filled by bank professionals only )</p>
            </div>
            <div className="invalid-feedback">
              You must enter Trace Number.
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Account Number*
            </label>
            <input
              type="number"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter account holder's name.
            </div>
          </div>
        </Col>
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Transaction Date*
            </label>
            <input
              type="text" // default type is text
              className="form-control"
              id="placeholderInput"
              placeholder="Select date"
              required
              defaultValue=""
              onFocus={(e) => (e.target.type = "date")} // show date picker on focus
              onBlur={(e) => {
                // revert to text if empty
                if (!e.target.value) {
                  e.target.type = "text";
                }
              }}
            />

            <div className="invalid-feedback">
              You must enter transaction date.
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={6} sm={12}>
          {" "}
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Claim/Dispute Amount*
            </label>
            <input
              type="number"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter claim/dispute amount.
            </div>
          </div>
        </Col>
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Transaction Bank/Merchant*
            </label>
            <input
              type="text"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter transaction bank/merchant.
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={6} sm={12}>
          {" "}
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Transaction Location/Country*
            </label>
            <input
              type="text"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter transaction location/country.
            </div>
          </div>
        </Col>
        <Col lg={6} sm={12}>
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Contact Number*
            </label>
            <input
              type="number"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter contact number.
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {" "}
          <div>
            <label htmlFor="placeholderInput" className="form-label text-black">
              Email Address*
            </label>
            <input
              type="text"
              className="form-control"
              id="placeholderInput"
              required
              defaultValue=""
            />
            <div className="invalid-feedback">
              You must enter email address.
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default AtmEcom
